import { VertTypography } from '@vertem-core/vertice-ds';
import { Tooltip } from 'antd';
import React from 'react';
import { LuHelpCircle } from 'react-icons/lu';
import PropTypes from 'prop-types';

const TitleTooltipHelp = ({ title, tooltipHelperText, sizeTitleTooltip='small' }) => {
  return (
    <VertTypography.Text className="payment-typograph">
      <span>{title}</span>
      <Tooltip
        title={tooltipHelperText}
        overlayClassName={`payment-tooltip-${sizeTitleTooltip}`}
        placement="top"
      >
        <LuHelpCircle size={16} />
      </Tooltip>
    </VertTypography.Text>
  );
};

export default TitleTooltipHelp;

TitleTooltipHelp.propTypes = {
  title: PropTypes.string.isRequired,
  tooltipHelperText: PropTypes.string.isRequired,
  sizeTitleTooltip: PropTypes.oneOf(['small', 'medium', 'large']),
};
